import React from "react";
import AppHeader from "./AppHeader.jsx";
import LoadingBar from "./LoadingBar.jsx";
import BrandFooter from "./BrandFooter.jsx";

/**
 * Shell for every page except Spend.
 *
 * The 232px left sidebar this used to render is gone — navigation moved into
 * AppHeader so the Spend page can use the full width for its three drill
 * panes. Spend renders AppHeader itself rather than going through here,
 * because it puts its freshness stamp and Refresh button in the header's
 * right-hand slot; the pages below have nothing to put there.
 */
export default function Layout({ children }) {
  return (
    <>
      <LoadingBar />
      <AppHeader />
      <main className="main">
        {children}
        <BrandFooter />
      </main>
    </>
  );
}
